import { useState } from 'react';

let autoGeneratedId = 0;
const useUniqueId = () => {
  const [asideId] = useState(() => ++autoGeneratedId);
  return asideId;
};

export { useUniqueId };
//# sourceMappingURL=useUniqueId.js.map
